'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint-disable max-len */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VisualWebsiteOptimizer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(VisualWebsiteOptimizer, _React$Component);

  function VisualWebsiteOptimizer() {
    (0, _classCallCheck3.default)(this, VisualWebsiteOptimizer);
    return (0, _possibleConstructorReturn3.default)(this, (VisualWebsiteOptimizer.__proto__ || (0, _getPrototypeOf2.default)(VisualWebsiteOptimizer)).apply(this, arguments));
  }

  (0, _createClass3.default)(VisualWebsiteOptimizer, [{
    key: 'render',
    value: function render() {
      if (!this.props.options || !this.props.options.enabled) {
        return null;
      }

      return _react2.default.createElement(_reactHelmet2.default, {
        script: [{
          type: 'text/javascript',
          innerHTML: '\n            var _vwo_code=(function(){\n            var account_id=' + this.props.options.accountId + ',\n            settings_tolerance=2000,\n            library_tolerance=2500,\n            use_existing_jquery=false,\n            /* DO NOT EDIT BELOW THIS LINE */\n            f=false,d=document;return{use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById(\'_vis_opt_path_hides\');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement(\'script\');b.src=a;b.type=\'text/javascript\';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName(\'head\')[0].appendChild(b);},init:function(){settings_timer=setTimeout(\'_vwo_code.finish()\',settings_tolerance);var a=d.createElement(\'style\'),b=\'body{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}\',h=d.getElementsByTagName(\'head\')[0];a.setAttribute(\'id\',\'_vis_opt_path_hides\');a.setAttribute(\'type\',\'text/css\');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load(\'//dev.visualwebsiteoptimizer.com/j.php?a=\'+account_id+\'&u=\'+encodeURIComponent(d.URL)+\'&r=\'+Math.random());return settings_timer;}};}());_vwo_settings_timer=_vwo_code.init();\n            '
        }]
      });
    }
  }]);
  return VisualWebsiteOptimizer;
}(_react2.default.Component), _class.propTypes = {
  options: _react.PropTypes.shape({
    enabled: _react.PropTypes.bool,
    accountId: _react.PropTypes.string
  })
}, _class.defaultProps = {}, _temp);
exports.default = VisualWebsiteOptimizer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/VisualWebsiteOptimizer/index.js
// module id = 553
// module chunks = 0